module.exports = __webpack_public_path__ + "static/media/5_2.6fd591a3.png";